const mqtt_username = 'gep-mqtt';
const mqtt_password = 'gep@gu@rdexp3rtpr0';

module.exports.dashboard = window.AppConfig.dashboardAccount;
module.exports.summon = window.AppConfig.summon;
module.exports.summon_billed = false
module.exports.scheduler = false;
if (window.AppConfig.external) {
    module.exports.external = window.AppConfig.external;
} else {
    module.exports.external = null;
}
//module.exports.external = `https://utmhr1.utm.my/ePelekat/PhotoStaff.ashx?nopekerja=`;
module.exports.logger = window.AppConfig.log;
module.exports.api = window.AppConfig.apiUrl;
exports.mqttBroker = `${window.AppConfig.mqttProto}://${mqtt_username}:${mqtt_password}@${window.AppConfig.mqttUrl}`;


// WEBPACK FOOTER //
// ./src/server.js